import PathHelper from './PathHelper.js';

export default class ApiBase {
    static MakeUrl(path) {
        const apiBaseUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}/`;
        //const apiBaseUrl = "https://localhost:44352/";
         //const apiBaseUrl = "http://140.110.11.110/";
        // const apiBaseUrl = "https://3d.wrbtycg.tw/ty3d-2nd";//https://localhost:44352/OviewProxy?
        let rtn = PathHelper.CombinePath(apiBaseUrl, path);
        return rtn;
    }
}